// Configuration for YOUR prediction market
export const config = {
  // YOUR actual token mint (not the other one)
  TOKEN_MINT: "5mbkMp8x4aZ9ntsVPPnVUFekiE1joGU4gSANfsTtiiaT",
  
  // Program ID
  PROGRAM_ID: "2Jso3cMEDPjQYx1nKsWPsCkJzzAj8kpVsTwq4PSRPGV1",
  
  // Config account
  CONFIG_ACCOUNT: "2KVj7Ja1ne8QGRq69aPwvfV7kie3rYzJzCvbvqsC2seB",
  
  // Network
  NETWORK: "devnet",
  RPC_URL: "https://api.devnet.solana.com",
  
  // Backend API - relative URLs work in both dev (Vite proxy) and production (Express serves everything)
  API_URL: (import.meta as any).env?.VITE_API_URL || "/api",
  WS_URL: (import.meta as any).env?.VITE_WS_URL || "",
  
  // API Keys
  API_FOOTBALL_KEY: (import.meta as any).env?.VITE_API_FOOTBALL_KEY || "ccf987181b1ed05feee434588799b8fc",
  
  // Token info
  TOKEN_SYMBOL: "TEST",
  TOKEN_DECIMALS: 9,
};
